import { cn } from "@devhop/ui";
import {
  CakeSlice,
  Coffee,
  Cookie,
  Croissant,
  CupSoda,
  Donut,
  GlassWater,
  IceCreamCone,
  Sandwich,
  Soup,
} from "lucide-react";
import type { ComponentType } from "react";

type ProductImagePlaceholderProps = {
  name: string;
  className?: string;
};

// Soft warm gradients that fit the café brand palette
const GRADIENTS = [
  "from-amber-100 to-orange-200 text-amber-900",
  "from-orange-100 to-rose-200 text-orange-900",
  "from-rose-100 to-pink-200 text-rose-900",
  "from-yellow-100 to-amber-200 text-yellow-900",
  "from-stone-100 to-amber-200 text-stone-800",
  "from-lime-100 to-emerald-200 text-emerald-900",
  "from-teal-100 to-cyan-200 text-teal-900",
  "from-sky-100 to-indigo-200 text-indigo-900",
  "from-violet-100 to-purple-200 text-purple-900",
  "from-red-100 to-orange-200 text-red-900",
];

// Food & drink icons rotated deterministically for visual variety
const ICONS: ComponentType<{ className?: string }>[] = [
  Coffee,
  CupSoda,
  GlassWater,
  IceCreamCone,
  Cookie,
  Croissant,
  Donut,
  Sandwich,
  CakeSlice,
  Soup,
];

function hashString(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
}

export function ProductImagePlaceholder({
  name,
  className,
}: ProductImagePlaceholderProps) {
  const hash = hashString(name);
  const gradient = GRADIENTS[hash % GRADIENTS.length];
  const Icon = ICONS[hash % ICONS.length];

  return (
    <div
      className={cn(
        "relative flex size-full items-center justify-center overflow-hidden bg-linear-to-br",
        gradient,
        className,
      )}
      aria-hidden
    >
      <Icon className="h-12 w-12 opacity-80 drop-shadow-sm" />
    </div>
  );
}
